/**
 * WalletBillingHistoryTabs Component
 *
 * Renders the billing history tabs (Plan Charges and Wallet History).
 * Handles wallet billing history data loading when wallet is supported.
 */
import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react-lite";
import { Tabs } from "../../../../components/tabs/tabs";
import WalletBillingHistoryTable from "./billing-history/wallet-billing-history-table";
import PlanChargesBillingTableCard from "../plan-charges-billing-table-card/plan-charges-billing-table-card";
import walletBillingHistoryStore from "../../stores/wallet/wallet-billing-history-store";

interface IWalletBillingHistoryTabsProps {
    isSupported: boolean;
    buttonContainerRef: React.RefObject<HTMLDivElement>;
}

const WalletBillingHistoryTabs: React.FC<IWalletBillingHistoryTabsProps> = observer(({
    isSupported,
    buttonContainerRef
}) => {
    useEffect(() => {
        if (isSupported) {
            walletBillingHistoryStore.loadPage(1);
        }
    }, [isSupported]);

    const tabs = useMemo(() => {
        const tabList = [
            {
                label: 'Plan Charges',
                content: <PlanChargesBillingTableCard buttonContainerRef={buttonContainerRef} />,
            },
        ];

        if (isSupported) {
            tabList.push({
                label: 'Wallet History',
                content: <WalletBillingHistoryTable buttonContainerRef={buttonContainerRef} />
            });
        }

        return tabList;
    }, [isSupported, buttonContainerRef]);

    return <Tabs tabs={tabs} />;
});

export default WalletBillingHistoryTabs;
